import { CodeVerifier } from "@whilecat/core/tasks/common/code-verifier.ts";
import { VerificationError } from "@whilecat/core/tasks/common/verification-error.ts";
import { type CodeEditorParams, CodeEditorParamsView } from "@whilecat/core/tasks/java/params/code-editor-params.ts";
import { isPresent } from "@whilecat/core/utils/objects.ts";
import { replaceTabsWithSpaces } from "@whilecat/core/utils/string.ts";
import { requireNotNull } from "@whilecat/core/utils/validation.js";
import type { CodeRunResult } from "@whilecat/services/java-compiler-service.js";

export class CodeEditorVerifier extends CodeVerifier {
    private data: CodeEditorParams;

    constructor(data: CodeEditorParams) {
        super(new CodeEditorParamsView(data));
        this.data = data;
    }

    checkResult(result: CodeRunResult) {
        requireNotNull(result);

        if (this.getParamsView().isExampleTask()) {
            return;
        }

        const cleanedOutput = replaceTabsWithSpaces(result.output);
        for (const possibleAnswer of this.data.correctAnswer) {
            // strict comparison
            if (isPresent(cleanedOutput) && possibleAnswer.trim() === cleanedOutput!.trim()) {
                return;
            }
        }

        if (isPresent(this.data.correctAnswerVerifier) && this.data.correctAnswerVerifier!(result)) {
            return;
        }

        // regex comparison;
        const regexp = this.data.correctAnswerRegExp;
        if (isPresent(regexp) && regexp!.test(cleanedOutput!)) {
            return;
        }

        // FIXME: randomize correct answer?
        throw new VerificationError(result);
    }
}
